export const SET_USER = 'SET_USER';

export const FETCH_USER_REQUEST = 'FETCH_USER/REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER/SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER/FAILURE';

export const FETCH_USER_FROM_SF_SUCCESS = 'FETCH_USER_FROM_SF/SUCCESS';
export const FETCH_USER_FROM_SF_ERROR = 'FETCH_USER_FROM_SF/FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_FAILURE';

export const FETCH_USER_PREFERENCES_REQUEST = 'FETCH_USER_PREFERENCES/REQUEST';
export const FETCH_USER_PREFERENCES_SUCCESS = 'FETCH_USER_PREFERENCES/SUCCESS';
export const FETCH_USER_PREFERENCES_ERROR = 'FETCH_USER_PREFERENCES/FAILURE';

export const FETCH_USER_SUBSCRIPTIONS_REQUEST = 'FETCH_USER_SUBSCRIPTIONS/REQUEST';
export const FETCH_USER_SUBSCRIPTIONS_SUCCESS = 'FETCH_USER_SUBSCRIPTIONS/SUCCESS';
export const FETCH_USER_SUBSCRIPTIONS_ERROR = 'FETCH_USER_SUBSCRIPTIONS/FAILURE';

export const UPDATE_USER_SUBSCRIPTIONS_REQUEST = 'UPDATE_USER_SUBSCRIPTIONS/REQUEST';
export const UPDATE_USER_SUBSCRIPTIONS_SUCCESS = 'UPDATE_USER_SUBSCRIPTIONS/SUCCESS';
export const UPDATE_USER_SUBSCRIPTIONS_ERROR = 'UPDATE_USER_SUBSCRIPTIONS/FAILURE';

export const ADD_USER_PREFERENCE_REQUEST = 'ADD_USER_PREFERENCE/REQUEST';
export const ADD_USER_PREFERENCE_SUCCESS = 'ADD_USER_PREFERENCE/SUCCESS';
export const ADD_USER_PREFERENCE_ERROR = 'ADD_USER_PREFERENCE/FAILURE';

export const ADD_USER_PREFERENCE = 'ADD_USER_PREFERENCE';
export const REMOVE_USER_PREFERENCE = 'REMOVE_USER_PREFERENCE';
export const MODIFY_USER_PREFERENCE_SUCCESS = 'MODIFY_USER_PREFERENCE_SUCCESS';
export const MODIFY_USER_PREFERENCE_FAIL = 'MODIFY_USER_PREFERENCE_FAIL';

export const REMOVE_USER_PREFERENCE_REQUEST = 'REMOVE_USER_PREFERENCE/REQUEST';
export const REMOVE_USER_PREFERENCE_SUCCESS = 'REMOVE_USER_PREFERENCE/SUCCESS';
export const REMOVE_USER_PREFERENCE_ERROR = 'REMOVE_USER_PREFERENCE/FAILURE';

export const SET_UPDATE_USER_SUCCESS = 'SET_UPDATE_USER_SUCCESS';

export const UPDATE_USER_MARKETING_LOCALE_REQUEST = 'UPDATE_USER_MARKETING_LOCALE_REQUEST';
export const UPDATE_USER_MARKETING_LOCALE_SUCCESS = 'UPDATE_USER_MARKETING_LOCALE_SUCCESS';
export const UPDATE_USER_MARKETING_LOCALE_ERROR = 'UPDATE_USER_MARKETING_LOCALE_ERROR';
